module.exports = __webpack_public_path__ + "icomoon.df5ec78b293c95790b08.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icomoon/icomoon.eot?1ofj2m
// module id = 147
// module chunks = 2